interface Props {
  title: string,
  value: any,
  icon: React.ElementType;
  colorClass: {
    bg: string,
    text: string,
    bgHover: string
  },
  linkText: string;
  onClick: () => void
}

function StatCard ({ title, value, icon: Icon, colorClass, linkText, onClick }: Props) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 relative overflow-hidden h-36">
      <div className="flex items-center space-x-4">
        <div className={`p-3 rounded-full ${colorClass.bg} ${colorClass.text}`}>
          <Icon size={28} />
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500">{title}</p>
          <p className="text-3xl font-bold text-gray-900">{value}</p>
        </div>
      </div>
      <div 
        className={`absolute bottom-0 left-0 right-0 p-2 text-xs font-medium text-center cursor-pointer ${colorClass.text} ${colorClass.bgHover} hover:opacity-90 transition-all`}
        onClick={onClick}
      >
        {linkText} &rarr;
      </div>
    </div>
  );
};

export default StatCard;